module.exports = __webpack_public_path__ + "img/img22.5000c447.png";